<template lang='pug'>
    section.inteligencia
        vue-iframe(
            :src='url',
            frame-id='my-ifram',
            @load='onLoad',
            name='my-frame'
        )
</template>

<script>
export default {
    name: 'index',

    data() {
        return {
            myIframe: null,
            url: 'https://vega.maps.arcgis.com/apps/dashboards/a306d27834b140f6ab27e509625010eb'
        };
    },

    methods: {
        onLoad(frame) {
            this.myIframe = frame.contentWindow;
        }
    }
};
</script>

<style scoped>
.inteligencia {
    height: 100%;
    width: 100%;
    padding: 20px;
}
</style>
